import { apiTruckType, emptyString, uiTruckType, unassignedPermit } from '../../constants';
export var vehicleRegistrationServicetoUiAdapter = function (registration) {
    var _a;
    return (_a = registration === null || registration === void 0 ? void 0 : registration.vehicleRegistration) === null || _a === void 0 ? void 0 : _a.map(function (item) {
        var _a, _b, _c, _d, _e, _f;
        return ({
            firstName: (_a = registration.user) === null || _a === void 0 ? void 0 : _a.firstName,
            lastName: (_b = registration.user) === null || _b === void 0 ? void 0 : _b.lastName,
            userAlias: registration.user.userAlias,
            registrationId: item.registrationId,
            vehicleType: item.vehicleInfo.vehicleType === apiTruckType ? uiTruckType : item.vehicleInfo.vehicleType,
            make: item.vehicleInfo.make,
            model: item.vehicleInfo.model,
            year: String(item.vehicleInfo.year),
            color: item.vehicleInfo.color,
            licensePlate: item.vehicleInfo.licensePlate,
            isNewLicenseChecked: item.vehicleInfo.licensePlate === 'NEW',
            state: item.vehicleInfo.vehicleLocation.state,
            registrationType: item.registrationType,
            parkingLocation: item.parkingLocation,
            permitNumber: item.permitNumber,
            registrationDate: item.registrationDate,
            expireInDays: (_c = item.expireInDays) === null || _c === void 0 ? void 0 : _c.toString(),
            isCarpoolChecked: false,
            ownerFirstName: item.vehicleInfo.ownerFirstName,
            ownerLastName: item.vehicleInfo.ownerLastName,
            chaufferName: (_d = item.vehicleInfo.chauffer) === null || _d === void 0 ? void 0 : _d.chaufferName,
            chaufferContactNumber: (_e = item.vehicleInfo.chauffer) === null || _e === void 0 ? void 0 : _e.chaufferContactNumber,
            chaufferDrivingLicense: (_f = item.vehicleInfo.chauffer) === null || _f === void 0 ? void 0 : _f.chaufferDrivingLicense,
            fuelType: item.vehicleInfo.fuelType ? item.vehicleInfo.fuelType : '',
            contactNumber: item.contactNumber ? item.contactNumber : '',
            disability: item.disability ? item.disability : false,
            parkingStickerCollected: item.parkingStickerCollected ? item.parkingStickerCollected : false,
        });
    });
};
export var vehicleRegistrationUitoServiceAdapter = function (vehicleRegistration) { return ({
    user: {
        firstName: vehicleRegistration.firstName,
        lastName: vehicleRegistration.lastName,
        userAlias: vehicleRegistration.userAlias,
    },
    vehicleRegistration: [
        {
            registrationId: vehicleRegistration.registrationId,
            registrationType: vehicleRegistration.registrationType,
            parkingLocation: vehicleRegistration.parkingLocation,
            permitNumber: vehicleRegistration.permitNumber.trim() !== emptyString ? vehicleRegistration.permitNumber : unassignedPermit,
            expireInDays: vehicleRegistration.expireInDays ? Number(vehicleRegistration.expireInDays) : 0,
            contactNumber: vehicleRegistration.contactNumber,
            disability: vehicleRegistration.disability,
            parkingStickerCollected: vehicleRegistration.parkingStickerCollected,
            vehicleInfo: {
                vehicleType: vehicleRegistration.vehicleType === uiTruckType ? apiTruckType : vehicleRegistration.vehicleType,
                make: vehicleRegistration.make,
                model: vehicleRegistration.model,
                year: vehicleRegistration.year ? Number(vehicleRegistration.year) : null,
                color: vehicleRegistration.color,
                licensePlate: vehicleRegistration.licensePlate,
                vehicleLocation: {
                    state: vehicleRegistration.state,
                },
                ownerFirstName: vehicleRegistration.ownerFirstName,
                ownerLastName: vehicleRegistration.ownerLastName,
                chauffer: {
                    chaufferName: vehicleRegistration.chaufferName,
                    chaufferContactNumber: vehicleRegistration.chaufferContactNumber,
                    chaufferDrivingLicense: vehicleRegistration.chaufferDrivingLicense,
                },
                fuelType: vehicleRegistration.fuelType,
            },
        },
    ],
}); };
export var updateVehicleRegistrationServiceAdapter = function (vehicleRegistration) { return ({
    registrationId: vehicleRegistration.registrationId,
    registrationType: vehicleRegistration.registrationType,
    parkingLocation: vehicleRegistration.parkingLocation,
    permitNumber: vehicleRegistration.permitNumber.trim() !== emptyString ? vehicleRegistration.permitNumber : unassignedPermit,
    expireInDays: vehicleRegistration.expireInDays ? Number(vehicleRegistration.expireInDays) : undefined,
    contactNumber: vehicleRegistration.contactNumber ? vehicleRegistration.contactNumber : '',
    disability: vehicleRegistration.disability,
    parkingStickerCollected: vehicleRegistration.parkingStickerCollected,
    vehicleInfo: {
        vehicleType: vehicleRegistration.vehicleType === uiTruckType ? apiTruckType : vehicleRegistration.vehicleType,
        make: vehicleRegistration.make,
        model: vehicleRegistration.model,
        year: vehicleRegistration.year ? Number(vehicleRegistration.year) : 0,
        color: vehicleRegistration.color,
        licensePlate: vehicleRegistration.licensePlate,
        vehicleLocation: {
            state: vehicleRegistration.state,
        },
        ownerFirstName: vehicleRegistration.ownerFirstName,
        ownerLastName: vehicleRegistration.ownerLastName,
        chauffer: {
            chaufferName: vehicleRegistration.chaufferName,
            chaufferContactNumber: vehicleRegistration.chaufferContactNumber,
            chaufferDrivingLicense: vehicleRegistration.chaufferDrivingLicense,
        },
        fuelType: vehicleRegistration.fuelType,
    },
}); };
